import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Dropdown } from 'react-bootstrap';
import { CatValidateFields } from '../validate/categoryValidation';
import ErrorFilter from '../../helper/errorFilter';
import { requestHandler } from '../../helper';
import { addCategory } from '../../controller';
import { toast } from 'react-toastify';
import SingleError from '../../helper/SingleError';

function CategoryAdd({ getCategoryData }) {

    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setCatData({})
    };
    const handleShow = () => setShow(true);
    const [submitCount, setSubmitCount] = useState(0);
    const [errors, setErrors] = useState({});


    const requireField = [
        "Name"
    ]

    const [catData, setCatData] = useState({
        name: '',
        status: true
    })


    const handleChange = async (e) => {
        const { name, value } = e.target;
        // let newValue = type === "checkbox" ? checked : value;
        if (submitCount > 0) {
            let validationErrors = CatValidateFields({ ...catData, [name]: value });
            validationErrors = ErrorFilter(validationErrors, requireField);
            setErrors(validationErrors);
            if (Object.keys(validationErrors).length === 0) {
                delete errors[name];
            }
        }
        setCatData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...catData };

        let validationErrors = CatValidateFields(updatedValues);
        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            await requestHandler(
                async () => await addCategory(updatedValues),
                null,
                (res) => {
                    toast.success(res.message);
                    handleClose();
                    setCatData({
                        name: '',
                        status: true
                    });
                    getCategoryData();
                },
                () => { }
            )
        }
    }
    const handleKeyPress = async (e) => {
        // Correct the key comparison to use '==='
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission
            await handleSubmit(e);
        }
    }

    return (
        <>
            <button className='add-btn' onClick={handleShow}>
                <img src="../images/png/plush.png" width={12} height={12} alt="" />
                <p className='m-0'>Add</p>
            </button>

            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Add Category</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <Form>
                            <Form.Group className="mb-3" controlId="formGroupEmail">
                                <Form.Label>Category Name</Form.Label>
                                <Form.Control type="text" placeholder="Add Category" name='name' value={catData.name} onChange={handleChange} onKeyDown={handleKeyPress} />
                                <SingleError error={errors?.name} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupPassword">
                                <Form.Label>Status</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        {catData.status ? 'Active' : 'Deactive'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setCatData({ ...catData, status: true })}>Active</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setCatData({ ...catData, status: false })}>Deactive</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button'> Cancel</button>
                                <button className='save-btn' type='button' onClick={handleSubmit}>Save</button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CategoryAdd